"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgCancelSecondary = function SvgCancelSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement("path", {
            d: "M25.82 4.74a1.23 1.23 0 00-.85.37l-9 9.16L7 5.11a1.23 1.23 0 00-.85-.37 1.25 1.25 0 00-.86.35 1.2 1.2 0 00-.29.85 1.15 1.15 0 00.34.86l9 9.2-9 9.2a1.2 1.2 0 000 1.71c.231.223.539.348.86.35a1.23 1.23 0 00.8-.37l9-9.16 9 9.16c.224.23.53.362.85.37.322.001.63-.125.86-.35a1.2 1.2 0 000-1.71l-9-9.2 9-9.2a1.15 1.15 0 00.29-.86c0-.32-.13-.627-.36-.85a1.22 1.22 0 00-.82-.35z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    );
};

exports.default = (0, _withContainer2.default)(SvgCancelSecondary);